import {
  forwardRef,
  ReactNode,
  ComponentPropsWithRef,
  ForwardedRef,
  useContext,
} from "react";
import { SplideSlide } from "@splidejs/react-splide";
import { CarouselContext } from "./tease-carousel";

export interface CarouselItemProps extends ComponentPropsWithRef<"div"> {
  children: ReactNode;
}

export const TeaseCarouselItem = forwardRef<HTMLDivElement, CarouselItemProps>(
  function CarouselItemWithRef(
    { children, ...rest }: CarouselItemProps,
    forwardedRef: ForwardedRef<HTMLDivElement>,
  ) {
    const { numItems, itemsRef } = useContext(CarouselContext);
    return (
      <SplideSlide className="hbs-tease-carousel-item">
        <div
          ref={(el) => {
            if (el && itemsRef?.current) {
              if (numItems && itemsRef.current.length >= numItems) {
                itemsRef.current = [el];
              } else {
                itemsRef.current.push(el);
              }
            }
            if (forwardedRef) {
              if (typeof forwardedRef === "function") {
                forwardedRef(el);
              } else {
                forwardedRef.current = el;
              }
            }
          }}
          {...rest}
        >
          {children}
        </div>
      </SplideSlide>
    );
  },
);
